"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconOperationAndMaintenance = function IconOperationAndMaintenance(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m3.353 36.242 14.964-14.965.182-.189a4.9 4.9 0 0 0 1.27-3.574 9.74 9.74 0 0 1 4.15-8.782l.269-.18a9.73 9.73 0 0 1 7.885-1.201l.124.036-5.534 5.536-.136.145a3 3 0 0 0 .136 4.1l2.47 2.47.145.135a3 3 0 0 0 1.977.744l.198-.007a3 3 0 0 0 1.925-.873l5.496-5.498.04.143A9.73 9.73 0 0 1 28.73 26.423a4.9 4.9 0 0 0-3.792 1.456L11.394 41.392l1.412 1.416 13.55-13.52.153-.145a2.9 2.9 0 0 1 2.085-.724 11.72 11.72 0 0 0 10.493-4.943 11.73 11.73 0 0 0 1.105-11.566l-.595-1.322-7.634 7.635-.1.087a1 1 0 0 1-1.315-.087l-2.47-2.47-.088-.1a1 1 0 0 1 .087-1.315l7.64-7.64-1.294-.604-.326-.146a11.73 11.73 0 0 0-16.324 11.7 2.9 2.9 0 0 1-.864 2.209L2.365 34.4q.455.945.988 1.84m12.063-8.785.708.706-4.34 4.35-.708-.706zm6.098.537-.708-.708-11.14 11.14.707.707z",
    clipRule: "evenodd"
  })));
};

export { IconOperationAndMaintenance, IconOperationAndMaintenance as default };
